import { isCondicaoAlcance, isCondicaoExecucao } from '@acme/core'

/** Alcance e execução ficam antes dos eventos, ligados sempre por "e". */
function grupoOrdem(condicaoId: string): number {
    if (isCondicaoAlcance(condicaoId)) return 0
    if (isCondicaoExecucao(condicaoId)) return 1
    return 2
}

/** Calcula para onde mover a condição em `index` para manter alcance → execução → eventos. */
export function indiceOrdenado(condicaoIds: string[], index: number): number {
    const grupo = grupoOrdem(condicaoIds[index])
    const anterior = condicaoIds[index - 1]
    const seguinte = condicaoIds[index + 1]
    const isNoLugar =
        (anterior === undefined || grupoOrdem(anterior) <= grupo) &&
        (seguinte === undefined || grupoOrdem(seguinte) >= grupo)
    if (isNoLugar) return index

    return condicaoIds.filter(
        (id, outro) => outro !== index && grupoOrdem(id) <= grupo,
    ).length
}

/** Só o evento que vem depois de outro evento escolhe E/OU; o resto é sempre E. */
export function isConectorEditavel(
    condicaoIds: string[],
    index: number,
): boolean {
    return (
        index > 0 &&
        grupoOrdem(condicaoIds[index - 1]) === 2 &&
        grupoOrdem(condicaoIds[index]) === 2
    )
}

/** Por que a linha não escolhe E/OU; `null` na primeira linha ou quando escolhe. */
export function motivoConectorTravado(
    condicaoIds: string[],
    index: number,
): string | null {
    if (index === 0 || isConectorEditavel(condicaoIds, index)) return null
    if (grupoOrdem(condicaoIds[index]) < 2)
        return 'Alcance e execução sempre restringem a rotina'

    return 'O primeiro evento se soma ao alcance e à execução com "e"'
}

/** Rótulo à esquerda da condição: "Quando", o conector dela ou "e" fixo. */
export function rotuloCondicao(
    condicoes: readonly { condicaoId: string; conector?: 'E' | 'OU' }[],
    index: number,
): string {
    if (index === 0) return 'Quando'
    const condicaoIds = condicoes.map(it => it.condicaoId)
    if (!isConectorEditavel(condicaoIds, index)) return 'e'

    return condicoes[index].conector === 'OU' ? 'ou' : 'e'
}
